import React from 'react'
import { createRoot } from 'react-dom/client'
import StudentExceptions from './components/StudentExceptions'

export let startStudentExceptions = (
  coursenum,
  studentPK,
  studentName,
  studentEmail,
  activityPK,
  activityTitle,
  accessData,
  lateData,
  timeData
) => {
  const root = createRoot(document.getElementById('react-app'))
  root.render(
    <StudentExceptions
      coursenum={coursenum}
      studentPK={studentPK}
      studentName={studentName}
      studentEmail={studentEmail}
      activityPK={activityPK}
      activityTitle={activityTitle}
      accessData={accessData}
      lateData={lateData}
      timeData={timeData}
    />
  )
}
